(function ($, undefined) {
    'use strict';

    $("#product_integration_id").on('change', function (e) {
        var optionSelected = $(this).find("option:selected");
        var valueSelected  = optionSelected.val();
        window.location.href = origin+"/products?integration_id="+valueSelected;
    });

})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/products.js